import { gql } from '@apollo/client'
import nationalContractReferenceWithType from './fragments/nationalContractReferenceWithType.fragment'

export const GET_SELECTABLE_NATIONAL_CONTRACT_REFERENCES = gql`
  query GetSelectableNationalContractReferences {
    getSelectableNationalContractReferences {
      ...NationalContractReferenceWithType
    }
  }
  ${nationalContractReferenceWithType}
`
